module.exports = __webpack_public_path__ + "img/banner_default.92ec790c.gif";